import {
  type ResourceType,
  ConditionOperatorEnum,
  type Provider,
} from '@repo/api-gw-sdk';
import { useMemo } from 'react';

import { useDAL } from '@/contexts/useDAL';
import { createCombineCondition } from '@/types/advanceFilter';

import { cloudProvider, resourceType } from './properties';

export const useResourceIdentifiers = (
  providers?: Provider[],
  resourceTypes?: ResourceType[]
) => {
  const dal = useDAL();
  const condition = useMemo(() => {
    const providersCondition = providers?.length
      ? [
          {
            property: cloudProvider.name,
            operator: ConditionOperatorEnum.In,
            value: providers,
          },
        ]
      : [];
    const resourceTypeCondition = resourceTypes?.length
      ? [
          {
            property: resourceType.name,
            operator: ConditionOperatorEnum.In,
            value: resourceTypes,
          },
        ]
      : [];
    const conditions = [...providersCondition, ...resourceTypeCondition];
    if (conditions.length === 0) {
      return undefined;
    }
    return createCombineCondition([
      ...providersCondition,
      ...resourceTypeCondition,
    ]);
  }, [providers, resourceTypes]);
  return dal.inventory.useListResourceIdentifiers(condition);
};
